var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", {
                domProps: {
                  innerHTML: _vm._s(_vm.data.consentpath.consentPathText)
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "card text-center" }, [
                _c("div", { staticClass: "form-check text-left" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.path,
                        expression: "path"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "radio",
                      name: "radio_choice",
                      id: "radio_1177",
                      value: "radio_1177"
                    },
                    domProps: { checked: _vm._q(_vm.path, "radio_1177") },
                    on: {
                      change: function($event) {
                        _vm.path = "radio_1177"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", {
                    staticClass: "form-check-label",
                    attrs: { for: "radio_1177" },
                    domProps: {
                      innerHTML: _vm._s(_vm.data.consentpath.firstChoiceText)
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check text-left" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.drugs.first_choice_drug,
                          expression: "drugs.first_choice_drug"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { disabled: _vm.path === "radio_calls_sms" },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.drugs,
                              "first_choice_drug",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          function($event) {
                            _vm.drugs.second_choice_drug = null
                          }
                        ]
                      }
                    },
                    [
                      _c("option", { domProps: { value: null } }, [
                        _vm._v(_vm._s(_vm.data.misc.chooseMedicationLabel))
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.data.misc.medicationList, function(
                        medValue,
                        medLabel
                      ) {
                        return _c(
                          "option",
                          {
                            key: medValue,
                            attrs: { disabled: medLabel.startsWith("—") },
                            domProps: { value: medValue }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(medLabel) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card text-center" }, [
                _c("div", { staticClass: "form-check text-left" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.path,
                        expression: "path"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "radio",
                      name: "radio_choice",
                      id: "radio_calls_sms",
                      value: "radio_calls_sms"
                    },
                    domProps: { checked: _vm._q(_vm.path, "radio_calls_sms") },
                    on: {
                      change: function($event) {
                        _vm.path = "radio_calls_sms"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", {
                    staticClass: "form-check-label",
                    attrs: { for: "radio_calls_sms" },
                    domProps: {
                      innerHTML: _vm._s(_vm.data.consentpath.secondChoiceText)
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check text-left" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.drugs.second_choice_drug,
                          expression: "drugs.second_choice_drug"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { disabled: _vm.path === "radio_1177" },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.drugs,
                              "second_choice_drug",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          function($event) {
                            _vm.drugs.first_choice_drug = null
                          }
                        ]
                      }
                    },
                    [
                      _c("option", { domProps: { value: null } }, [
                        _vm._v(_vm._s(_vm.data.misc.chooseMedicationLabel))
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.data.misc.medicationList, function(
                        medValue,
                        medLabel
                      ) {
                        return _c(
                          "option",
                          {
                            key: medValue,
                            attrs: { disabled: medLabel.startsWith("—") },
                            domProps: { value: medValue }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(medLabel) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check text-left" }, [
                  _c("div", { staticClass: "clearfix--min" }),
                  _vm._v(" "),
                  _c("label", {
                    attrs: { for: "phone" },
                    domProps: {
                      innerHTML: _vm._s(_vm.data.consentpath.phoneNumberLabel)
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group sm-3" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.phoneNumber,
                          expression: "phoneNumber"
                        }
                      ],
                      ref: "phone",
                      staticClass: "form-control phone-number-input",
                      attrs: {
                        inputmode: "numeric",
                        placeholder: "07X XXX XX XX",
                        autocomplete: "off",
                        type: "text",
                        name: "phoneNumber",
                        maxlength: 12,
                        disabled: _vm.path === "radio_1177"
                      },
                      domProps: { value: _vm.phoneNumber },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.phoneNumber = $event.target.value
                          },
                          function($event) {
                            return _vm.enforceNumbers()
                          }
                        ]
                      }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-consent btn-primary btn-lg btn-block",
                  attrs: {
                    disabled: !_vm.firstChoiceValid && !_vm.secondChoiceValid
                  },
                  on: {
                    click: function($event) {
                      return _vm.giveConsentPath()
                    }
                  }
                },
                [_vm._v("\n          OK\n        ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("small", {
                staticClass: "text-muted",
                domProps: {
                  innerHTML: _vm._s(_vm.data.consent.consentDisclaimer)
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm" })
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "progress" }, [
      _c("div", {
        staticClass: "progress-bar",
        staticStyle: { width: "66%" },
        attrs: {
          role: "progressbar",
          "aria-valuenow": "66",
          "aria-valuemin": "0",
          "aria-valuemax": "100"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76d11c42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76d11c42","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConsentPath.vue
// module id = null
// module chunks = 